import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Tooltip } from '../../components';
import ErrorMessage from '../ErrorMessage/ErrorMessages';
import styles from './TextInput.module.scss';

const cx = classNames.bind(styles);

const TextInput = React.forwardRef(({ label, errors, isRequired, tooltip, ...defaultProps }, ref) => {
	return (
		<div className={styles.formField}>
			<label className={styles.label} htmlFor={defaultProps.name}>
				<span>{label} {isRequired ? '*' : ''}</span>

				{tooltip && <Tooltip content={tooltip} />}
			</label>
			<input
				className={cx('input', { error: errors && errors[defaultProps.name] })}
				ref={ref}
				{...defaultProps}
			/>
			{errors && errors[defaultProps.name] && errors[defaultProps.name].message && <ErrorMessage name={defaultProps.name} errors={errors} />}
		
		</div>
	);
});

TextInput.propTypes = {
	label: PropTypes.string.isRequired,
	errors: PropTypes.object,
	isRequired: PropTypes.bool,
	tooltip: PropTypes.string,
};

export default TextInput;
